const DEFAULT_VIEWPORT_PADDING = 8;
const DEFAULT_GAP = 4;

export function computeSubmenuFlyoutPosition(
  anchorRect: DOMRect,
  options?: { width?: number; maxHeight?: number; gap?: number; padding?: number }
): { top: number; left: number } {
  const width = options?.width ?? 280;
  const maxHeight = options?.maxHeight ?? 280;
  const padding = options?.padding ?? DEFAULT_VIEWPORT_PADDING;
  const gap = options?.gap ?? DEFAULT_GAP;

  const vw = window.innerWidth;
  const vh = window.innerHeight;

  const fitsRight = anchorRect.right + gap + width <= vw - padding;
  const fitsLeft = anchorRect.left - gap - width >= padding;

  let left: number;
  let top = anchorRect.top;

  if (fitsRight) {
    left = anchorRect.right + gap;
  } else if (fitsLeft) {
    left = anchorRect.left - width - gap;
  } else {
    left = Math.max(padding, Math.min(anchorRect.left, vw - width - padding));
    top = anchorRect.bottom + gap;
  }

  if (top + maxHeight > vh - padding) {
    top = Math.max(padding, vh - maxHeight - padding);
  }
  if (top < padding) {
    top = padding;
  }

  return { top, left };
}

export function computePanelAboveAnchorPosition(
  anchorRect: DOMRect,
  options?: { width?: number; maxHeight?: number; gap?: number; padding?: number }
): { top: number; left: number } {
  const width = options?.width ?? 360;
  const maxHeight = options?.maxHeight ?? 420;
  const gap = options?.gap ?? 8;
  const padding = options?.padding ?? DEFAULT_VIEWPORT_PADDING;

  const vw = window.innerWidth;
  const vh = window.innerHeight;

  let left = anchorRect.left;
  if (left + width > vw - padding) {
    left = vw - width - padding;
  }
  if (left < padding) {
    left = padding;
  }

  let top = anchorRect.top - maxHeight - gap;
  if (top < padding) {
    top = Math.min(anchorRect.bottom + gap, vh - maxHeight - padding);
  }

  return { top, left };
}
